import React, { createContext, useContext } from 'react';
import { Trek } from 'utils/analytics';

import useAccount, { UseAccountState } from './useAccount';

const initialContext: UseAccountState = {
  loading: true,
  account: null,
  realAccountId: undefined,
};

const AuthContext = createContext<UseAccountState>(initialContext);

const useAuthContext = (): UseAccountState => useContext(AuthContext);

const AuthContextProvider = ({ children }) => {
  const authState = useAccount();

  return (
    <AuthContext.Provider value={authState}>
      <Trek context={{ account: authState.account }}>{children}</Trek>
    </AuthContext.Provider>
  );
};

export { useAuthContext, AuthContextProvider };
